export default "__VITE_ASSET__0a991d4c__"